const SLIDER_KEY = Symbol("slider");

const showChange = (el: any, binding: any, useTransition = true) => {
  if (useTransition) {
    clearTimeout(el[SLIDER_KEY].timer);
    el.style.transition =
      "height 0.3s ease, opacity 0.3s ease, margin 0.3s ease";
  }
  el.style.overflow = "hidden";
  requestAnimationFrame(() => {
    el.style.height =
      Number(binding.value) === 1 ? el[SLIDER_KEY].height + "px" : "0";
    el.style.marginTop = Number(binding.value) === 1 ? "" : "0";
    el.style.marginBottom = Number(binding.value) === 1 ? "" : "0";
    el.style.opacity = Number(binding.value) === 1 ? "1" : "0";
    el.style.zIndex = Number(binding.value) === 1 ? "unset" : "-1";
    el[SLIDER_KEY].timer = setTimeout(() => {
      if (Number(binding.value) === 1) {
        el.style.overflow = el[SLIDER_KEY].overflow;
      }
      el.style.transition = el[SLIDER_KEY].transition;
    }, 300);
  });
};

export const vSliderShow = {
  inserted: (el: any, binding: any) => {
    el[SLIDER_KEY] = {
      height: 0,
      transition: "",
      overflow: "",
      timer: 0
    };
  },
  componentUpdated: (el: any, binding: any) => {
    const source = el.style.height;
    el.style.height = "auto";
    if (!el[SLIDER_KEY].height || el.scrollHeight !== el[SLIDER_KEY].height) {
      el[SLIDER_KEY].height = el.scrollHeight;
      el[SLIDER_KEY].transition = el.style.transition;
      el[SLIDER_KEY].overflow = el.style.overflow;
    }
    el.style.height = source;
    if (binding.value === binding.oldValue) {
      showChange(el, binding, false);
      return;
    }
    showChange(el, binding);
  },
  unbind: (el: any) => {
    delete el[SLIDER_KEY];
  }
};
